import {Grid} from "@mui/material";
import Formulario_Crear_Bebidas from "./Formulario_Crear_Bebidas";
import Formulario_Crear_Misterio from "./Formulario_Crear_Misterio";

const Crear_Misterio_Dashboard = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container justifyContent={'center'}
                  alignItems={'center'} size={{xs: 12, sm: 12, md: 12}} sx={{px:3,pt:8}}>
                <Grid container justifyContent={'center'} alignItems={'center'} size={{xs: 12, sm: 12, md: 12}}>
                    <Formulario_Crear_Misterio/>
                </Grid>
            </Grid>

        </Grid>
    )

}
export default Crear_Misterio_Dashboard;